import {registerLocale} from 'react-datepicker'
import {de, es, frCA, fr, it, ja, nb, nl, pt, sk, tr} from 'date-fns/locale'

registerLocale('de', de)
registerLocale('es', es)
registerLocale('fr', frCA)
registerLocale('fr_fr', fr)
registerLocale('it', it)
registerLocale('jp', ja)
registerLocale('nl', nl)
registerLocale('sk', sk)
registerLocale('tr', tr)
registerLocale('nb', nb)
registerLocale('pt', pt)

window.I18n.fallbacks = true
window.I18n.defaultLocale = 'en'
window.I18n.locales['fr_fr'] = [ 'fr_fr', 'fr', 'en' ]

window.I18n.pluralization['jp'] = () => [ 'other' ]
